export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_oubfq2x",
  TEMPLATE_ADMIN_ID: "template_ixjmn8c",
  TEMPLATE_CUSTOMER_ID: "template_ixjmn8c",
  TEMPLATE_PAYMENT_ID: "template_f2pp43k", // Template ID של תבנית אישור התשלום
  PUBLIC_KEY: "IKLyKL12H85FK_0Y9",
};

